module.exports = __webpack_public_path__ + "static/flags/NF-a309b08eda4228f78269eef7c222106e.gif";